export enum RouteNames {
  MAIN_PAGE = '',
  LOGIN_PAGE = 'login',
  FORBIDDEN_PAGE = 'forbidden',
  NOT_FOUND_PAGE = 'not-found',
  JOURNAL_PAGE = 'journal',
  HOME = 'home',
  TICKETS = 'tickets',
  RESET_PASSWORD_PAGE = 'reset-password',
}
export enum RouteParams {
  ID = 'id',
}
